export default __webpack_public_path__ + "static/media/new-setting.50f02d9f.png";